<script lang="ts">
	import { NavBar } from '#lib/features/navigation/components/NavBar/index.js';
	import { GlobalRoutes } from '#lib/features/navigation/constants/global-routes.js';
	import { GlobalSearch } from '#lib/features/search/global/components/GlobalSearch/index.js';
	import { TalksRoutes } from '#lib/websites/talks/constants/routes.js';
	import { YouTubeIcon } from '$global/assets/icons/YouTubeIcon';
	import { HeniTalksLogo } from '$global/assets/logos/HeniTalksLogo';
	import { IconLink } from '$global/components/IconLink';
	import { LinkButton } from '$global/components/LinkButton';
	import { SiteLink } from '$global/features/navigation/components/SiteLink';
	import { SocialsLinks } from '$global/features/navigation/constants/links';
	import { createNavPopover } from '$global/features/navigation/utils/createNavPopover';
	import { SearchPageContainer } from '$global/features/search/components/SearchPageContainer';
	import { createSearchCombobox } from '$global/features/search/utils/createSearchCombobox';

	interface Props {
		children?: import('svelte').Snippet;
	}

	let { children }: Props = $props();

	const combobox = createSearchCombobox();

	let popover = createNavPopover();

	const handleClose = () => popover.close();

	const siteLinks = [
		{
			label: 'Films',
			dataCy: 'films',
			href: TalksRoutes.Gallery,
		},
		{
			label: 'Podcasts',
			dataCy: 'podcasts',
			href: TalksRoutes.Podcasts,
		},
		{
			label: 'Speakers',
			dataCy: 'speakers',
			href: TalksRoutes.Speakers,
		},
	];
</script>

<NavBar
	{combobox}
	SearchComponent={GlobalSearch}
	{siteLinks}
	isSearchEnabled={true}
>
	{#snippet homeIcon()}
		<IconLink
			dataCy="header"
			href={GlobalRoutes.TalksHome}
			label="See HENI Talks home page"
			class="outline-none"
		>
			<HeniTalksLogo class="xs:scale-100 origin-left scale-75" />
		</IconLink>
	{/snippet}

	{#snippet rightLink()}
		<span class="w-full">
			<SiteLink
				{handleClose}
				dataCy="youtube-header"
				href={SocialsLinks.YouTube}
				class="xs:scale-100 border-t border-gray-200 lg:hidden"
				label="See HENI Talks YouTube channel"
			>
				<span class="flex items-center gap-2">
					<YouTubeIcon hexCode="#FF0000" />
					HENI Talks YouTube Channel
				</span>
			</SiteLink>
			<LinkButton
				href={SocialsLinks.YouTube}
				newTab
				variant="secondary"
				size="sm"
				icon
				dataCy="youtube-header"
				class="ml-5 hidden lg:block"
				buttonProps={{ class: 'normal-case' }}
				>{#snippet leading()}
					<YouTubeIcon hexCode="#FF0000" class="!h-[20px] !w-[20px]" />
				{/snippet} YouTube</LinkButton
			>
		</span>
	{/snippet}
</NavBar>

<SearchPageContainer {combobox}>
	{@render children?.()}
</SearchPageContainer>
